/**
 * Service Slider
 */

import Swiper, { Navigation } from 'swiper';

jQuery( $ => { // eslint-disable-line no-unused-vars
	new Swiper( '.services-related .swiper-container', {
		modules: [ Navigation ],
		slidesPerView: 1,
		spaceBetween: 30,
		navigation: {
			nextEl: '.services-related-next',
			prevEl: '.services-related-prev',
		},
		breakpoints: {
			640: {
				slidesPerView: 2,
			},
			960: {
				slidesPerView: 3,
			},
			1200: {
				slidesPerView: 4,
			},
		},
	} );
} );
